"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Pilates = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Pilates, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Pilates);

  function Pilates() {
    (0, _classCallCheck2["default"])(this, Pilates);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pilates, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M8.49363309,10.3727464 C9.63763309,11.8631574 10.7376331,13.3535684 11.8376331,14.8905547 C12.6736331,14.2384999 17.0740843,10.7919245 18.7020843,9.95356835 C19.1860843,9.72069164 20.1719036,9.70746206 20.3919036,10.1732155 C20.7127044,10.3413133 20.7344715,11.4641745 20.291928,11.8262306 C19.4022796,12.5540749 13.2456331,17.7316505 12.4096331,18.5700067 C11.2656331,19.7343903 9.63763309,19.4549382 8.80163309,18.4302807 C8.36163309,17.8713766 7.96563309,17.3124725 7.52563309,16.7535684 C6.51363309,15.4028834 5.54563309,14.0987738 4.53363309,12.7480889 C3.82963309,11.7700067 3.82963309,10.5124725 4.48963309,9.62754096 C4.84163309,9.20836288 5.28163309,8.97548616 5.76563309,8.88233548 C6.95363309,8.60288342 8.14163309,8.37000671 9.32963309,8.09055466 C9.50563309,8.04397931 9.68163309,7.95082863 9.85763309,7.90425329 C11.0016331,7.29877383 12.1456331,6.73986972 13.3336331,6.13439027 C13.6856331,5.9480889 14.0816331,5.9480889 14.4336331,6.18096561 C14.7416331,6.41384233 14.8736331,6.73986972 14.8296331,7.15904781 C14.7856331,7.53165055 14.6096331,7.76452726 14.3016331,7.95082863 C12.9816331,8.64945877 11.6616331,9.3480889 10.2976331,9.95356835 C9.85763309,10.1398697 9.32963309,10.2046486 8.49363309,10.3727464 Z M23,21.769863 C15.652,21.769863 8.348,21.769863 1,21.769863 C1,21.2109589 1,20.6054795 1,20 C8.304,20 15.608,20 23,20 C23,20.2794521 23,20.6054795 23,20.8849315 C23,21.1643836 23,21.4438356 23,21.769863 Z M2.672,6.23561644 C2.672,5.02465753 3.64,4 4.784,4 C5.928,4 6.896,5.02465753 6.896,6.23561644 C6.896,7.44657534 5.928,8.47123288 4.784,8.47123288 C3.64,8.47123288 2.672,7.44657534 2.672,6.23561644 Z"
      }));
    }
  }]);
  return Pilates;
}(_react["default"].PureComponent);

var _default = Pilates;
exports["default"] = _default;